// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"5a207779","450":"81545346","488":"c8420a5c"}[chunkId] + ".chunk.js";
};